(function () {
  var count = document.querySelector("[data-cart-count]");
  var drawer = document.querySelector("[data-cart-drawer]");
  var body = document.querySelector("[data-cart-body]");
  var suppressClick = false;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function rate(qty) {
    if (qty >= 3) return 0.2;
    if (qty >= 2) return 0.1;
    if (qty >= 1) return 0.05;
    return 0;
  }

  function render(cart) {
    if (count) count.textContent = cart.item_count;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = "<p>Your cart is empty.</p>";
      return;
    }
    var rows = cart.items.map(function (item) {
      var unit = item.original_price || item.price;
      return '<div class="oe-line"><div><strong>' + item.product_title + '</strong><div>' +
        item.quantity + ' × ' + money(unit) + '</div></div><button type="button" data-remove="' +
        item.key + '">Remove</button></div>';
    }).join("");
    var original = cart.original_total_price || cart.total_price;
    var discount = cart.total_discount;
    if (!discount) discount = Math.round(original * rate(cart.item_count));
    var due = original - discount;
    body.innerHTML = rows +
      '<div class="oe-drawer__totals"><span>Merchandise</span><span>' + money(original) + '</span></div>' +
      '<div class="oe-drawer__totals"><span>Checkout discount</span><span>-' + money(discount) + '</span></div>' +
      '<div class="oe-drawer__totals"><strong>Estimated total</strong><strong>' + money(due) + '</strong></div>' +
      '<p>1 item 5%, 2 items 10%, 3 or more 20%. Buy 2 items and get free shipping. Delivery in 5–8 business days.</p>' +
      '<a class="oe-btn oe-btn--fill" href="/checkout">Checkout</a>';
  }

  function openCart() {
    drawer.hidden = false;
  }

  function refresh() {
    return fetch("/cart.js").then(function (response) { return response.json(); }).then(render);
  }

  function showSlide(root, index) {
    var slides = root.querySelectorAll("[data-slide]");
    if (!slides.length) return;
    var next = (index + slides.length) % slides.length;
    slides.forEach(function (slide, item) { slide.hidden = item !== next; });
    root.querySelectorAll("[data-slide-dot]").forEach(function (dot, item) {
      dot.classList.toggle("is-on", item === next);
    });
    root.setAttribute("data-index", String(next));
  }

  function railStep(rail) {
    var card = rail.querySelector("article");
    if (!card) return 320;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  document.addEventListener("click", function (event) {
    if (suppressClick) {
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    var add = event.target.closest("[data-add]");
    var qtyInput = document.querySelector("[data-qty]");
    if (add) {
      var quantity = qtyInput && add.closest(".oe-pdp") ? Number(qtyInput.value || 1) : 1;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(add.getAttribute("data-add")), quantity: quantity })
      }).then(refresh).then(openCart);
    }
    if (event.target.closest("[data-cart-open]")) refresh().then(openCart);
    if (event.target.closest("[data-cart-close]")) drawer.hidden = true;
    var remove = event.target.closest("[data-remove]");
    if (remove) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: remove.getAttribute("data-remove"), quantity: 0 })
      }).then(function (response) { return response.json(); }).then(render);
    }
    var more = event.target.closest("[data-review-more]");
    if (more) {
      var reviewBody = more.parentElement.querySelector(".oe-review__body");
      var opened = reviewBody.classList.toggle("is-open");
      more.textContent = opened ? "Read less" : "Read more";
    }
    var pageBtn = event.target.closest("[data-review-page]");
    if (pageBtn) {
      var reviewRoot = pageBtn.closest("[data-reviews]");
      var pageButtons = Array.prototype.filter.call(reviewRoot.querySelectorAll("[data-review-page]"), function (button) {
        var value = button.getAttribute("data-review-page");
        return value !== "prev" && value !== "next";
      });
      var current = 1;
      pageButtons.forEach(function (button) {
        if (button.classList.contains("is-on")) current = Number(button.getAttribute("data-review-page"));
      });
      var raw = pageBtn.getAttribute("data-review-page");
      var page = Number(raw);
      if (raw === "next") page = Math.min(pageButtons.length, current + 1);
      if (raw === "prev") page = Math.max(1, current - 1);
      pageButtons.forEach(function (button) {
        button.classList.toggle("is-on", Number(button.getAttribute("data-review-page")) === page);
      });
      reviewRoot.querySelectorAll("[data-review-item]").forEach(function (item) {
        item.hidden = Number(item.getAttribute("data-review-item")) !== page;
      });
    }
    var write = event.target.closest("[data-write-review]");
    if (write) {
      var writeForm = write.parentElement.querySelector("[data-write-form]");
      if (writeForm) writeForm.hidden = !writeForm.hidden;
    }
    var full = event.target.closest("[data-full-ingredients]");
    if (full) {
      var inci = full.parentElement.querySelector("[data-inci]");
      if (inci) inci.hidden = !inci.hidden;
    }
    var reviewTab = event.target.closest("[data-review-tab]");
    if (reviewTab) {
      var reviewWrap = reviewTab.closest("[data-reviews]");
      var reviewName = reviewTab.getAttribute("data-review-tab");
      reviewWrap.querySelectorAll("[data-review-tab]").forEach(function (button) {
        button.classList.toggle("is-on", button === reviewTab);
      });
      reviewWrap.querySelectorAll("[data-review-panel]").forEach(function (panel) {
        panel.hidden = panel.getAttribute("data-review-panel") !== reviewName;
      });
    }
    var keyRow = event.target.closest(".oe-keys details");
    if (keyRow && event.target.closest("summary")) {
      var shot = keyRow.getAttribute("data-shot");
      var photo = keyRow.closest("[data-keys]").querySelector("[data-key-photo]");
      if (shot && photo) photo.src = shot;
    }
    var thumb = event.target.closest("[data-thumb]");
    if (thumb) {
      var gallery = thumb.closest("[data-gallery]");
      var pick = Number(thumb.getAttribute("data-thumb"));
      gallery.querySelectorAll("[data-gallery-image]").forEach(function (image, index) {
        image.hidden = index !== pick;
      });
      gallery.querySelectorAll("[data-thumb]").forEach(function (button) {
        button.classList.toggle("is-on", button === thumb);
      });
    }
    if (event.target.closest("[data-nav-toggle]")) {
      document.querySelector("[data-nav]").classList.toggle("is-open");
    }
    if (event.target.closest("[data-search-toggle]")) {
      var search = document.querySelector("[data-search]");
      search.hidden = !search.hidden;
      if (!search.hidden) search.querySelector("input").focus();
    }
    var tab = event.target.closest("[data-tab]");
    if (tab) {
      var name = tab.getAttribute("data-tab");
      document.querySelectorAll("[data-tab]").forEach(function (button) {
        button.classList.toggle("is-on", button === tab);
      });
      var empty = document.querySelector("[data-empty]");
      var showEmpty = name === "body" || name === "fragrance";
      if (empty) empty.hidden = !showEmpty;
      document.querySelectorAll("[data-product-group]").forEach(function (card) {
        card.hidden = showEmpty || (name !== "all" && card.getAttribute("data-product-group") !== name);
      });
    }
    var slideRoot = event.target.closest("[data-slides]");
    if (slideRoot && event.target.closest("[data-slide-prev]")) {
      showSlide(slideRoot, Number(slideRoot.getAttribute("data-index") || 0) - 1);
    }
    if (slideRoot && event.target.closest("[data-slide-next]")) {
      showSlide(slideRoot, Number(slideRoot.getAttribute("data-index") || 0) + 1);
    }
    var dot = event.target.closest("[data-slide-dot]");
    if (dot) showSlide(dot.closest("[data-slides]"), Number(dot.getAttribute("data-slide-dot")));
    var railButton = event.target.closest("[data-rail-prev], [data-rail-next]");
    if (railButton) {
      var wrap = railButton.closest("section");
      var rail = wrap ? wrap.querySelector("[data-rail]") : null;
      if (rail) {
        var step = railStep(rail);
        rail.scrollLeft += railButton.hasAttribute("data-rail-next") ? step : -step;
      }
    }
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target && event.target.closest ? event.target.closest("[data-write-form]") : null;
    if (!form) return;
    event.preventDefault();
    var name = form.querySelector("[name=name]").value.trim();
    var title = form.querySelector("[name=title]").value.trim();
    var body = form.querySelector("[name=body]").value.trim();
    if (!name || !title || !body) return;
    var article = document.createElement("article");
    article.className = "oe-review";
    article.setAttribute("data-review-item", "1");
    var who = document.createElement("div");
    who.className = "oe-review__who";
    var nameEl = document.createElement("p");
    nameEl.className = "oe-review__name";
    nameEl.textContent = name;
    who.appendChild(nameEl);
    var time = document.createElement("time");
    time.className = "oe-review__date";
    var now = new Date();
    time.textContent = (now.getMonth() + 1) + "/" + now.getDate() + "/" + String(now.getFullYear()).slice(2);
    var main = document.createElement("div");
    main.className = "oe-review__main";
    var heading = document.createElement("h3");
    heading.textContent = title;
    var copy = document.createElement("p");
    copy.className = "oe-review__body is-open";
    copy.textContent = body;
    main.appendChild(heading);
    main.appendChild(copy);
    article.appendChild(who);
    article.appendChild(time);
    article.appendChild(main);
    var first = form.closest("[data-reviews]").querySelector("[data-review-item]");
    if (first) first.parentElement.insertBefore(article, first);
    form.reset();
    form.hidden = true;
  });

  var drag = null;
  document.addEventListener("pointerdown", function (event) {
    if (event.pointerType !== "mouse" || event.button !== 0) return;
    var rail = event.target.closest("[data-rail]");
    if (!rail || event.target.closest("a, button, input")) return;
    drag = { rail: rail, x: event.pageX, left: rail.scrollLeft, moved: false };
  });
  document.addEventListener("pointermove", function (event) {
    if (!drag) return;
    var dx = event.pageX - drag.x;
    if (Math.abs(dx) > 5) drag.moved = true;
    if (drag.moved) drag.rail.scrollLeft = drag.left - dx;
  });
  document.addEventListener("pointerup", function () {
    if (!drag) return;
    var rail = drag.rail;
    var moved = drag.moved;
    drag = null;
    if (!moved) return;
    suppressClick = true;
    var step = railStep(rail);
    rail.scrollLeft = Math.round(rail.scrollLeft / step) * step;
  });
  document.addEventListener("dragstart", function (event) {
    if (event.target.closest("[data-rail]")) event.preventDefault();
  });

  refresh();
})();
